/**
 * Tooth Chart V1 — common-diagnosis quick chips.
 *
 * The 8 chip labels cover ~80% of chairside charting flows. Each chip
 * carries a default severity so a single tap fills BOTH the textarea
 * AND the severity dropdown — collapsing the diagnose-and-save flow
 * from ~5 steps to 2 taps.
 *
 * The dentist can still edit the content + severity before saving; this
 * is a workflow accelerator, not a constraint.
 */

export const COMMON_DIAGNOSES = [
  { label: 'Caries',       severity: 'moderate' },
  { label: 'RCT needed',   severity: 'moderate' },
  { label: 'Sensitivity',  severity: 'mild' },
  { label: 'Fracture',     severity: 'moderate' },
  { label: 'Mobility',     severity: 'mild' },
  { label: 'Extraction',   severity: 'moderate' },
  { label: 'Watch',        severity: 'mild' },
  { label: 'Implant',      severity: null },
];
